import { render, staticRenderFns } from "./PodaciVozila.vue?vue&type=template&id=3dc20564&"
import script from "./PodaciVozila.vue?vue&type=script&lang=ts&"
export * from "./PodaciVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports